import React from 'react'
import { MenuItem, TextField } from '@mui/material'

/**
 * Per Day vs Per CheckOut attribution slicer.
 *
 * Affects the Monthly chart only (KPIs and breakdowns stay per-checkout
 * in this iteration):
 *   - per_checkout (default) → revenue lands fully on the pickup date.
 *   - per_day                → revenue is spread across each rental day.
 *
 *   value = 'per_checkout' | 'per_day'
 *   onChange(value, { intent: 'instant' })
 */
export default function ProrateSlicer({ value, onChange }) {
	return (
		<TextField select size="small" label="Attribute"
		           value={value || 'per_checkout'}
		           onChange={(e) => onChange(e.target.value, { intent: 'instant' })}
		           sx={{ minWidth: 170 }}>
			<MenuItem value="per_checkout">Per CheckOut</MenuItem>
			<MenuItem value="per_day">Per Day</MenuItem>
		</TextField>
	)
}
